module.exports = __webpack_public_path__ + "static/media/fruits_49.c0ce3b8d.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_49.csv
// module id = 716
// module chunks = 0